"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/table/style/css");
var table_1 = __importDefault(require("antd/lib/table"));
require("antd/lib/space/style/css");
var space_1 = __importDefault(require("antd/lib/space"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var pages_1 = require("../../hooks/pages");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var ModalListView = /*#__PURE__*/ react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var modalsInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.modals.initialFetchDone;
    });
    var modalsFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.modals.isFetching;
    });
    var modals = (0, react_redux_1.useSelector)(function (state) {
        return state.modals.items;
    });
    // noinspection JSUnusedGlobalSymbols
    var columns = (0, react_1.useMemo)(function () {
        return [{
                title: "Title",
                dataIndex: "title"
            }, {
                title: "Close Button Text",
                dataIndex: "close_text"
            }, {
                title: "Last Modified",
                sorter: function sorter(a, b) {
                    return new Date(a.revision.timestamp) - new Date(b.revision.timestamp);
                },
                render: function render(station) {
                    return new Date(station.revision.timestamp).toLocaleString();
                }
            }, {
                title: "Actions",
                key: "actions",
                shouldCellUpdate: function shouldCellUpdate(r, pr) {
                    return (r === null || r === void 0 ? void 0 : r.id) !== (pr === null || pr === void 0 ? void 0 : pr.id);
                },
                render: function render(modal) {
                    return (0, jsx_runtime_1.jsxs)(space_1.default, {
                        size: "small",
                        children: [(0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/modals/detail/".concat(modal.id));
                                },
                                children: "View"
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                                onClick: function onClick() {
                                    return navigate("/modals/edit/".concat(modal.id));
                                },
                                children: "Edit"
                            }), (0, jsx_runtime_1.jsx)(button_1.default, {
                                icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}),
                                danger: true,
                                disabled: true,
                                children: "Delete"
                            })]
                    });
                }
            }];
    }, [navigate]);
    var onAdd = (0, react_1.useCallback)(function () {
        return navigate("/modals/add");
    }, [navigate]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                type: "primary",
                icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}),
                onClick: onAdd,
                children: "Add New"
            }, "add")];
    }, [onAdd]);
    var pagination = (0, pages_1.useUrlPagination)();
    return (0, jsx_runtime_1.jsx)(page_header_1.default, {
        ghost: false,
        title: "Modals",
        subTitle: "View and edit app modals",
        extra: extra,
        children: (0, jsx_runtime_1.jsx)(table_1.default, {
            bordered: true,
            size: "small",
            loading: !modalsInitialFetch && modalsFetching,
            columns: columns,
            dataSource: modals,
            rowKey: "id",
            pagination: pagination
        })
    });
});
exports.default = ModalListView;
